import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import { definitionFor, isSourceDeclarationKey } from '../utils/declarations';
const sourceIcons = {
  original: 'fas fa-pen-nib',
  repost: 'fas fa-link',
  reference: 'fas fa-quote-left'
};
export default class SourceDeclaration extends Component {
  view(vnode) {
    const hasOtherDeclarations = vnode.attrs.declarations.some(item => definitionFor(item.key()) && !isSourceDeclarationKey(item.key()));
    if (hasOtherDeclarations) return null;
    const declaration = vnode.attrs.declarations.find(item => isSourceDeclarationKey(item.key()));
    if (!declaration) return null;
    if (declaration.key() === 'original') {
      return m("section", {
        className: "CreatorDeclarationSource"
      }, m("span", null, app.translator.trans('ffans-creator-declarations.forum.display.original_notice')));
    }
    const source = declaration.metadata()?.details;
    const title = declaration.metadata()?.title;
    if (!source) return null;
    return m("section", {
      className: "CreatorDeclarationSource"
    }, m(Icon, {
      name: sourceIcons[declaration.key()],
      className: `CreatorDeclarationSource-icon CreatorDeclarationSource-icon--${declaration.key()}`
    }), m("span", null, app.translator.trans(`ffans-creator-declarations.forum.display.${declaration.key()}_notice`, {
      source: m("a", {
        href: source,
        target: "_blank",
        rel: "noopener noreferrer nofollow ugc"
      }, title || source)
    })));
  }
}
flarum.reg.add('ffans-creator-declarations', 'forum/components/SourceDeclaration', SourceDeclaration);